/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryListCategoryResponse } from './CarpCategoryListCategoryResponse';

export type CarpCategoryListCategoryResponseApiRespoonse = {
    data?: CarpCategoryListCategoryResponse;
    status?: CarpCategoryListCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryListCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

